import { useState } from "react";
import { Avatar, Tag } from "antd";
import { UserOutlined } from "@ant-design/icons";

export default function HoverUserCard({ email, role, extra }) {
  const [hovered, setHovered] = useState(false);

  const name = email?.split("@")[0] || "User";
  const initial = name?.[0]?.toUpperCase() || "U";

  // Role → color mapping (extendable)
  const getRoleTag = (role) => {
    if(!role){
      return ''
    }
    switch (role?.toLowerCase()) {
      case "admin":
        return <Tag color="red">Admin</Tag>;
      default:
        return <Tag color="default">{role || "User"}</Tag>;
    }
  };

  return (
    <div className="w-full px-2 flex justify-end">
      <div className="flex items-center justify-end bg-white shadow-sm rounded-full overflow-hidden h-11 transition-all duration-300">

        {/* Extra */}
        <div
          className={`flex items-center gap-2 pl-2 transition-all duration-200
                      ${hovered ? "opacity-0 pointer-events-none" : "opacity-100"}`}
        >
          {extra}
        </div>

        {/* Info */}
        <div
          className={`overflow-hidden text-right transition-all duration-300
                      ${hovered ? "opacity-100 max-w-[280px]" : "opacity-0 max-w-0"}`}
        >
          <div className="whitespace-nowrap w-[100%] pr-2 flex flex-col items-end gap-1">
            <div className="text-sm  w-[100%] font-medium text-gray-800 truncate">
              {name}
            </div>

            {/* Role Tag */}
            <div className="scale-90 origin-right">
              {getRoleTag(role)}
            </div>
          </div>
        </div>

        {/* Avatar trigger */}
        <div
          className="flex items-center justify-center w-11 h-11 cursor-pointer"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <Avatar

            size={32}
            className="!bg-blue-500"
            icon={!email && <UserOutlined />}
          >
            {email ? initial : null}
          </Avatar>
        </div>
      </div>
    </div>
  );
}
